import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { getStyle, SERVICE_FLEET, SERVICE_WORKSHOP } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBSubHeading from '../../shared/CBSubHeading';
import { withRouter } from 'react-router';
import NavbarButton from '../../shared/NavbarButton';
import { Route } from 'react-router-dom';
import DataImportMileage from './DataImportMileage';
import {
  fetchOrganizations as _fetchOrganizations,
  updateOrganization as _updateOrganization,
} from '../../../actions/organizationActions';
import CBInputField from '../../shared/form_components/CBInputField';
import CBButtonSubmit from '../../shared/CBButtonSubmit';
import CBButtonWithIconSmall from '../../shared/CBButtonWithIconSmall';
import CBSubmitButton from '../../shared/form_components/CBSubmitButton';

class PredictedMaintenanceSettings extends React.Component {
  state = {
    // If initialData is a list of strings, set formData directly to that array
    formData: [],
    edited: false
  };

  componentDidMount = () => {
    const { fetchOrganizations, organizations, selectedOrganizationId } = this.props;
    fetchOrganizations();
  };

  handleInputChange = (index, newValue) => {
    this.setState(prevState => {
      const updatedFormData = [...prevState.formData];
      updatedFormData[index] = newValue;
      return { formData: updatedFormData, edited: true };
    });
  };

  handleAddField = () => {
    this.setState(prevState => ({
      formData: [...prevState.formData, ''],
      edited: true
    }));
  };

  handleRemoveField = (index) => {
    this.setState(prevState => {
      const updatedFormData = prevState.formData.filter((_, i) => i !== index);
      return { formData: updatedFormData, edited: true };
    });
  };

  handleSubmit = () => {
    const { onSubmit, updateOrganization, selectedOrganizationId, organizations } = this.props;
    // Simply pass back the list of strings
    const selectedOrganization = organizations.find((org) => org.id == selectedOrganizationId);
    const newSettings = {...selectedOrganization.settings};
    const newJobList = [...this.state.formData];

    if (!newSettings.predicted_maintenances) {
      newSettings.predicted_maintenances = {
        periodic_maintenance_tasks: newJobList
      };
    } else {
      newSettings.predicted_maintenances.periodic_maintenance_tasks = newJobList;
    }

    const newOrganization = {
      ...selectedOrganization,
      settings: newSettings
    }

    updateOrganization(selectedOrganizationId, newOrganization);
    this.setState({edited: false})
  };

  componentDidUpdate(prevProps) {
    const { selectedWorkshopId, selectedOrganizationId, organizations } = this.props;
    const { formData, edited } = this.state;

    let selectedOrganization = null;

    if(organizations && organizations.length > 0) {
      selectedOrganization = organizations.find((org) => org.id == selectedOrganizationId)
    }

    if (!selectedOrganization) {
      return;
    }

    let newPeriodicMaintenanceTasks = [];

    if (selectedOrganization.settings.predicted_maintenances && selectedOrganization.settings.predicted_maintenances.periodic_maintenance_tasks) {
      newPeriodicMaintenanceTasks = selectedOrganization.settings.predicted_maintenances.periodic_maintenance_tasks;
    }

    if (((selectedOrganizationId !== prevProps.selectedOrganizationId) || (!prevProps.organizations || prevProps.organizations.length == 0)) || (!edited && formData.length != newPeriodicMaintenanceTasks.length) ) {
      this.setState({
        formData: newPeriodicMaintenanceTasks
      })
    }
  }

  render() {
    const {
      t,
      service,
      selectedWorkshopId,
      user,
      selectedOrganizationId,
      organizations,
    } = this.props;

    const { formData, edited } = this.state;
    const selectedOrganization = organizations.find((org) => org.id == selectedOrganizationId);
    const isEmployee = selectedOrganization && selectedOrganization.user_role === "employee" && !user.is_staff;

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'sectionContainer')}>
              <CBSubHeading>
                {t('periodicMaintenanceTaskFields')}
              </CBSubHeading>
              <p style={{marginTop: 8}}>{t('periodicMaintenanceTaskFieldsDescription')}</p>
              <h5 style={{ marginTop: 16, color: 'white' }}><strong>{t('usageInstructions')}</strong></h5>
              <p style={{ marginTop: 8 }}>
                {t('instruction1')}
                {' '}
                {t('instruction2')}
              </p>
              <ul style={{ marginTop: 4, marginBottom: 8, paddingLeft: 24, color: 'white' }}>
                <li>{t('instruction3')}</li>
                <li>{t('instruction4')}</li>
                <li>{t('instruction5')}</li>
              </ul>
            </div>
            <div style={getStyle(screenSize, styles, 'formContainer')}>
              {formData.map((fieldValue, index) => (
                <div
                  key={index}
                  style={getStyle(screenSize, styles, 'fieldContainer')}
                >
                  <CBInputField
                    disabled={isEmployee}
                    name={`field-${index}`}
                    value={fieldValue}
                    placeholder={t('fieldValue', { ns: 'common' })}
                    onChange={(e) => this.handleInputChange(index, e.value)}
                    inputStyle={getStyle(screenSize, styles, 'input')}
                    labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                  />
                  <CBButtonWithIconSmall
                    disabled={isEmployee}
                    style={getStyle(screenSize, styles, 'button')}
                    onClick={() => this.handleRemoveField(index)}
                    text={t('removeField', { ns: 'common' })}
                    textStyle={getStyle(screenSize, styles, 'buttonText')}
                  />
                </div>
              ))}
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <CBButtonWithIconSmall
                  disabled={isEmployee}
                  onClick={this.handleAddField}
                  text={t('addField', { ns: 'common' })}
                  textStyle={getStyle(screenSize, styles, 'buttonText')}
                />
                <CBSubmitButton
                  disabled={!edited || isEmployee}
                  onClick={this.handleSubmit}
                  text={t('save', { ns: 'common' })} />
              </div>
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    formContainer: {
      maxWidth: 800
    },
    container: {
      padding: 32,
      display: 'flex',
      flexDirection: 'column',
    },
    sectionContainer: {
      marginBottom: 16,
    },
    fieldContainer: {
      marginBottom: '12px',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
    input: {
      backgroundColor: '#ebebeb',
      fontSize: 14,
      textAlign: 'center',
      resize: 'none',
      color: 'black',
      borderRadius: 100,
      height: 40,
      border: 'none',
      width: '100%',
    },
    buttonText: {
      fontSize: 14,
      fontWeight: 700,
      color: '#0095da',
      padding: 8,
      margin: 0,
    },
    button: {
      width: 200,
      border: '2px solid #0095da50',
      color: '#0095da',
      borderRadius: 50,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    inputLabelText: {
      color: 'black',
    },
  },
  medium: {
    container: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    service: state.app.service,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedOrganizationId: state.organization.selectedOrganization,
    organizationRequest: state.organization,
    organizations: state.organization.organizations,
    loading: state.organization.organizationListStatus.loading,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchOrganizations: _fetchOrganizations,
    updateOrganization: _updateOrganization,
  }
)(withRouter(translate('SettingsView')(PredictedMaintenanceSettings)));
